import { Dispatch, SetStateAction } from 'react';
import { formatMonthYear } from '../../lib/helpers/formatMonthYear/formatMonthYear';
import {
  DECEMBER_OF_CURRENT_YEAR,
  JANUARY_OF_CURRENT_YEAR,
} from '../../model/consts/months';
import { IRangeDates } from '../../model/types/IRangeDates';
import { IMonthRangePickerWithOptionsProps } from '../../month-range-picker-with-options';
import styles from '../../month-range-picker-with-options.module.scss';

interface IProps {
  setSelectedOption: Dispatch<
    SetStateAction<IMonthRangePickerWithOptionsProps['selectedOption']>
  >;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  setDates: (dates: IRangeDates) => void;
  selectedOption?: number;
  getOptionsClassnames: (index: number) => string;
}

const MonthRangePickerCurrentYearOption = ({
  setSelectedOption,
  setShowOptions,
  setDates,
  getOptionsClassnames,
}: IProps) => {
  const handleCurrentYearOptionClick = () => {
    setSelectedOption(0);
    setShowOptions(false);
    setDates({
      start: JANUARY_OF_CURRENT_YEAR,
      end: DECEMBER_OF_CURRENT_YEAR,
    });
  };

  return (
    <div
      className={getOptionsClassnames(0)}
      onClick={handleCurrentYearOptionClick}
    >
      <div className={styles.optionTitle}>За текущий год</div>
      <div className={styles.optionDesc}>
        {formatMonthYear(JANUARY_OF_CURRENT_YEAR)} -{' '}
        {formatMonthYear(DECEMBER_OF_CURRENT_YEAR)}
      </div>
    </div>
  );
};

export default MonthRangePickerCurrentYearOption;
